import { Dialog, DialogContent } from '@material-ui/core';
import styled from 'styled-components';

export const LabelPrintWriteOffDialogContainer = styled(Dialog)`
  width: 100%;

  .MuiPaper-root {
    width: 100%;
  }

  /* PHONE */
  @media only screen and (max-width: 576px) {
    .MuiDialog-container {
      align-items: flex-start;
      margin-top: 50px;
    }

    .MuiPaper-root {
      margin: 32px 10px;
    }
  }

  /* SMALL TABLET */
  @media (min-width: 577px) and (max-width: 602px) {
    width: 80%;
  }

  /* MEDIUM TABLET */
  @media (min-width: 602px) and (max-width: 801px) {
    width: 60%;
  }

  /* LARGE TABLET */
  @media (min-width: 801px) and (max-width: 1024px) {
    width: 50%;
  }

  @media (min-width: 1025px) {
    width: 30%;
  }
`;

export const PrintWriteOffDialogContent = styled(DialogContent)`
  padding: 0;
`;

export const PrintWriteOffTopInfos = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-bottom: solid 1px #d0d3e2;
  padding-bottom: 15px;
  margin: 15px 0;

  span {
    color: #5062f0;
    font-size: 14px;

    &.title {
      font-weight: bold;
      font-size: 16px;
      margin-bottom: 5px;
    }
  }
`;

export const PrintWriteOffBottomInfos = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;

  span {
    color: #0b0d1d;
    text-align: center;
    font-weight: bold;
    font-size: 14px;
  }
`;

export const WriteOffNumberOfLabelsContainer = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;

  span {
    color: #454a67;
    font-size: 16px;
  }

  .MuiFormControl-root {
    border: solid 1px #010311;
    border-radius: 8px;
    padding: 12px 8px;
    width: 23%;

    input {
      margin-bottom: 3px;
    }

    fieldset {
      border: none;
    }
  }
`;
